import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "291",
  "slug": "spot-norway-from-satellite-imagery",
  "title": "How to Recognise Norway in Satellite Images",
  "excerpt": "Mainland Norway has a long, indented Atlantic coast backed by mountain terrain.",
  "date": "2026-05-01",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/norway.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Mainland Norway has a long, indented Atlantic coast backed by mountain terrain. In western Norway, fjords extend far inland and divide the coast into peninsulas and islands. The southeastern region around Oslo has a different mixture of lowland, forests, and settled valleys."
    },
    {
      "type": "heading",
      "text": "Fjords along a mountainous mainland"
    },
    {
      "type": "paragraph",
      "text": "Trace Sognefjord from the coast into the mountains. Compare its branching outline with the less deeply cut coast around Oslo. This overview excludes Svalbard."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Glaciated coasts also occur in Chile and New Zealand. A single branching inlet cannot settle the country. Use several coastal features and their orientation, then compare the surrounding terrain."
    }
  ],
  "imageAlt": "Norway regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
